import { render, staticRenderFns } from "./ManageCampaignRuleSet.vue?vue&type=template&id=55f23a38&"
import script from "./ManageCampaignRuleSet.vue?vue&type=script&lang=js&"
export * from "./ManageCampaignRuleSet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports